export default Object.freeze({
    general: 'showGeneral',
    openingComments: 'showOpeningComments',
    analyses: 'showAnalyses',
    inventory: 'showInventory',
    closingComments: 'showClosingComments',
    commentsAndPictures: 'showAnnexComments',
    analysisResult: 'showSamples',
    appendices: 'showAppendices',
    flowMeter: 'showFlowMeter',
    productLevel: 'showProductLevel',
    fuelMeter: 'showFuelMeter',
    massBalance: 'showMassBalance',
    graphs: 'showGraphs',
});
